export default __webpack_public_path__ + "static/media/portfolio-145.a8f93eb9.jpg";